<template>
    <div>
        <div class="search-container primary mb10 mt10">
            <div class="form-box">
                <input class="input-field" v-model="title" placeholder="请输入服务项目名称"/>
                <button class="search-btn" @click="getMsuList()"><i class="icon iconfont icon-search"></i></button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="msuList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                <el-table-column width="55">

                    <template slot-scope="rows">
                        <div class="copy-radio ml15" :class="{'circle' : selMsu!= null && selMsu.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="fileBrowseUrl" label="图片" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileBrowseUrl != null">
                            <img class="wh100" :src="scope.row.fileBrowseUrl"/>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="服务项目名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="toDoorFee" label="上门费(元)" align="right">
                    <template slot-scope="rows">
                        <div v-if="rows.row.toDoorFee != null">
                            <span>{{((rows.row.toDoorFee).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="参考人工费(元)" align="right">
                    <template slot-scope="rows">
                        <div v-if="rows.row.workHourFee != null">
                            <span>{{((rows.row.workHourFee).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="参考价格(元)" align="right">
                    <template slot-scope="rows">
                        <div v-if="rows.row.generallFee != null">
                            <span>{{((rows.row.generallFee).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="wrntPeriod" label="质保期(单位：天)" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import servcApi from '../../api/servc'

    export default {
        name: 'swb-msu-list-by-goodsId-and-merchantId-for-select',
        desc: '服务选择',
        props: {
            goodsId: {
                type: Number
            },
            srcVendorId: {
                type: Number
            },
            sellerType: {
                type: Number
            },
            type: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                msuList: [],
                title: null,
                selMsu: null
            }
        },
        created: function () {
            this.getMsuList();
        },
        methods: {
            getMsuList: function () {
                let self = this;
                let postData = {};
                if(!Utils.isNoB(self.title)) {
                    postData.title = self.title;
                }
                if(!Utils.isNoB(self.type)) {
                    postData.type = self.type;
                }
                postData.goodsId = self.goodsId;
                postData.merchantId = self.srcVendorId;
                postData.merchantType = self.sellerType;
                let theLoad = MsgBox.loading();
                servcApi.getMsuListByGoodsIdAndMerchantIdAndMerchantType(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.msuList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.selMsu = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let result = {};
                //
                let selMsu = this.selMsu;
                if(selMsu != null && selMsu.id > 0) {
                    result.type = 'info';
                    result.data = selMsu;
                } else {
                    result.type = 'warn';
                    result.message = '请选择服务！';
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/servc/MsuListByGoodsIdAndMerchantIdForSelect.vue